export default import.meta.ROLLDOWN_FILE_URL_ks5YAJ2FYO7Gp3xJ$8WfPQ